import Vuex from 'vuex'
import Vue from 'vue'
import mutations from './mutations'
import actions from './actions'
import getters from './getters';
import { getSessionStore } from 'Libs/sessionStorage.js';
import {getLocalStore} from 'Libs/localStorage.js';
import { SAVE_USERBREIF, SAVE_ACTIVITY, SAVE_MEDIA_ACCOUNT, SAVE_ROUTER } from './mutation-types.js';

Vue.use(Vuex);

const state = {
    userBreif: {},
    activity: {},
    realUserInfo: {},
    status: {
        //是否登录
        login: false,
        allowAccess: false
    },
    curRouter: {
        meta: {
            isActivity: ''
        }
    },
    mediaAccounts: getLocalStore('mediaAccounts') !=null ? JSON.parse(getLocalStore('mediaAccounts')):[], //用户媒体账号
    mediaDistributeCovers: '',
    mediaDistributeData: {},
    accountRejectReason: '',
    reportNum: 0,
    noticeList: [],
    webEnv: '',
    apiEnv: '',
    banInfo: {
        isBan: false,
        reason: ''
    },
    hasAuth: false
};

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})
